// #334: marker colours for the map, in a module with no Leaflet import.
//
// They live here rather than in `leaflet-icons.js` because the legend needs
// them too, and that module pulls in Leaflet and its CSS — which crash under
// jsdom, and are excluded from coverage for exactly that reason. A component
// that only wants two hex strings should not have to drag a mapping library
// into the test environment with it.
//
// Values are brand-500 / amber-500 from the Tailwind theme. Amber is the same
// hue the `past` pill on a card uses, so the map and the list agree on what
// "past" looks like.
export const UPCOMING_MARKER_COLOR = '#2a72ff'
export const UPCOMING_MARKER_STROKE = '#13388f'
export const PAST_MARKER_COLOR = '#f59e0b'
export const PAST_MARKER_STROKE = '#92400e'
